import {API_URL, apiRequest} from "./api";
import axios, {AxiosResponse} from "axios";
import { getAuthToken } from "../components/security/AuthContext";

const API_AI_AGENT_URL = `${API_URL}/ai-agent`;

// Agents API Methods
export const fetchAllAgents = async () => {
  return apiRequest('GET', API_AI_AGENT_URL);
};

export const fetchAgentByUuid = async (uuid: string) => {
  return apiRequest('GET', `${API_AI_AGENT_URL}/${uuid}`);
};

export const saveOrUpdateAgent = async (agent: any) => {
  return apiRequest('POST', API_AI_AGENT_URL, agent);
};

export const deleteAgent = async (uuid: string) => {
  return apiRequest('DELETE', `${API_AI_AGENT_URL}/${uuid}`);
};

export const processFile = async (
  agentUuid: string,
  formData: FormData,
  onProgress: (progress: number) => void
): Promise<string> => {
  try {
    const response: AxiosResponse<string> = await axios.post(
      `${API_URL}/ai-agent/${agentUuid}/process-file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getAuthToken()}`,
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
          onProgress(progress); // Update progress
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Error uploading file:", error.message);
    throw new Error(error.response?.data?.message || "Error processing file");
  }
};

